import { showPopconfirm } from '../../../comps/Popconfirm';
import { listComponentMixin, tabsContainerMixin } from "../../../../lib/helpers";
import TabsList from "../Tabs/TabsList";
const __script_base__ = {
  name: 'WArrayTabs',
  mixins: [listComponentMixin, tabsContainerMixin],
  props: {
    pageletId: {
      type: String,
      required: true
    },
    allowAdd: {
      type: Boolean
    },
    allowDelete: {
      type: Boolean
    },
    allowSort: {
      type: Boolean
    },
    onDelete: {
      type: Function,
      default: null
    }
  },
  components: {
    TabsList
  },
  provide() {
    return {
      'uicore:WTabs': this
    };
  },
  data() {
    return {
      emulateEmptyMode: false,
      currentIndex: 0,
      allTabs: []
    };
  },
  methods: {
    gotoIndex(index) {
      this.currentIndex = index;
    },
    handleAddButtonClick() {
      this.addItem();
      this.currentIndex = this.array.length - 1;
    },
    handleTabDelete(idx, event) {
      var _this$onDelete;
      (((_this$onDelete = this.onDelete) === null || _this$onDelete === void 0 ? void 0 : _this$onDelete.call(this, idx, this)) || showPopconfirm(this, {
        content: `确定要删除 ${this.allTabs[idx].title} 吗？`,
        clientX: event.clientX,
        clientY: event.clientY,
        options: [{
          label: '确定',
          value: true,
          primary: true
        }, {
          label: '取消',
          value: false
        }]
      }).then(confirmed => {
        if (!confirmed) throw new Error('rejected');
      })).then(() => {
        this.deleteItem(idx);
        this.currentIndex = Math.min(this.array.length - 1, this.currentIndex);
      }, () => {});
    },
    handleDragEnd({
      oldIndex,
      newIndex
    }) {
      const copy = this.array.slice();
      const picked = copy.splice(oldIndex, 1);
      const safeNewIndex = Math.min(newIndex, copy.length); // draggable 在存在换行+footer时会有bug导致 newIndex 偏大
      copy.splice(safeNewIndex, 0, ...picked);
      this.array = copy;
      this.currentIndex = safeNewIndex;
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "uc-tabs w-arrayTabs"
  }, [_c('tabs-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.emptySlotShown,
      expression: "!emptySlotShown"
    }],
    attrs: {
      "uc-designer-interactive": "true",
      "current": _vm.currentIndex,
      "tabs": _vm.allTabs,
      "allow-add": _vm.allowAdd && !_vm.finalReadonly,
      "allow-delete": _vm.allowDelete && !_vm.finalReadonly,
      "allow-sort": _vm.allowSort && !!_vm.arrayLength && !_vm.finalReadonly
    },
    on: {
      "goto": _vm.gotoIndex,
      "add": _vm.handleAddButtonClick,
      "delete": _vm.handleTabDelete,
      "sort": _vm.handleDragEnd
    }
  }), _vm._v(" "), _vm._l(_vm.itemRendererData, function (ref) {
    var slotProps = ref.slotProps;
    var index = ref.index;
    var key = ref.key;
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.currentIndex === index,
        expression: "currentIndex===index"
      }],
      key: key,
      ref: "arrayItemContainers",
      refInFor: true,
      staticClass: "uc-tabs-content-wrap w-arrayTabs-item",
      attrs: {
        "data-index": index
      }
    }, [_vm._t("item", null, null, slotProps)], 2);
  }), _vm._v(" "), _vm.emptySlotShown ? _c('div', {
    ref: "empty",
    staticClass: "w-arrayTabs-emptySlot uc-slotForBlocks"
  }, [_vm._t("empty", function () {
    return [_c('div', {
      staticClass: "w-array-emptyDefault"
    }, [_c('p', [_vm._v("没有内容")]), _vm._v(" "), _vm.allowAdd && !_vm.finalReadonly ? _c('p', [_c('button', {
      staticClass: "uc-button w-arrayTabs-add",
      on: {
        "click": _vm.handleAddButtonClick
      }
    }, [_vm._v("\n            添加\n          ")])]) : _vm._e()])];
  })], 2) : _vm._e()], 2);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/ArrayTabs/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);